module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "createfoldermodal",
    attrs: {
      "id": _vm.modalId,
      "title": _vm.currentTitle,
      "name": "create-folder-modal",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Create",
      "ok-disabled": !_vm.folderName || _vm.errors.has('name'),
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "ok": _vm.handleOk
    },
    nativeOn: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleOk($event)
      }
    }
  }, [_c('form', {
    attrs: {
      "id": "create-folder-form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 100,
        regex: /^[^\\]+$/
      }),
      expression: "{ required: true, max: 100, regex: /^[^\\\\]+$/ }"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Folder name",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.folderName),
      callback: function($$v) {
        _vm.folderName = $$v
      },
      expression: "folderName"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    attrs: {
      "name": "warning"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), (_vm.currentProject && !_vm.parentFolderId) ? _c('span', [_vm._v("This will be added to the root of project "), _c('strong', [_vm._v(_vm._s(_vm.currentProject.name))])]) : _vm._e(), _vm._v(" "), (_vm.currentProject && _vm.parentFolderId) ? _c('span', [_vm._v("This will be added to the project "), _c('strong', [_vm._v(_vm._s(_vm.currentProject.name))])]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Creating\n  ")], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-010ae44e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CreateFolderModal.vue
// module id = 990
// module chunks = 1